export default {
  discount_badge: '{{value}} off',
  high_caffeine_warning_required: 'High caffeine',
  pfand: 'Incl. {{value}} deposit',
  alcohol_by_volume_percent: '{{value}} % Vol. Alcohol',
};
